module.exports = __webpack_public_path__ + "img/img39.6ca955fc.png";